import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  private prefix = 'ES logger ';
  private logs = {};
  constructor() {
    window['logger'] = this;
  }


  log(message:string){
    message = message +this.prefix;
    let date = Date.now();
    this.logs[date] = message;
  }

  getLogs(){
    return this.logs;
  }

  getLogByDate(date){
    return this.logs[date] || null;
  }

  getPrevLog(){
    return this.logs[Object.keys(this.logs)[Object.keys(this.logs).length - 2]];
  }

  getLastLog(){
    return this.logs[Object.keys(this.logs)[Object.keys(this.logs).length - 1]];
  }

  private getDate():string{
    let resultStr = '';
    let date = new Date(Date.now());
    resultStr+=` ${date.toLocaleString()}.${date.getMilliseconds()}`;
    return resultStr;
  }
}
